import script from "./MoveToCollectionModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoveToCollectionModal.vue?vue&type=script&lang=ts&setup=true"

import "./MoveToCollectionModal.vue?vue&type=style&index=0&id=6fec28fc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fec28fc"]])

export default __exports__